import React from 'react';

function Footer() {
	return (
		<footer className='footer'>
			<p className='attribution'>
				Challenge by{' '}
				<a
					className='link link--dark'
					href='https://www.frontendmentor.io?ref=challenge'
					target='_blank'
					rel='noreferrer'>
					Frontend Mentor
				</a>
				. Coded by{' '}
				<a className='link link--dark' href='https://github.com/JepardMay'>
					Veronika Palto
				</a>
				.
			</p>
		</footer>
	);
}

export default Footer;
